export const loginAction = (userLoginData) => ({
	type: "USER_LOGGED_IN",
	loginData: userLoginData
});

export const updateJWT = (newToken) => ({
	type: "USER_UPDATED_JWT",
	newToken
});

export const updateUser = (userData) => ({
	type: "USER_UPDATED",
	userData
});

export const logout = () => ({
	type: "USER_LOGGED_OUT"
});



// WEBPACK FOOTER //
// ./src/actions/UserActions.js